import React from 'react';
import { ButtonLink } from '../ui/ButtonLink';
export function HomeAudiences() {
  return <section className="grid lg:grid-cols-2" aria-label="Get started" data-id="element-189" data-mp="2g4mv0zej6gka">
      <div className="on-dark bg-aubergine px-6 py-20 text-porcelain sm:px-12 lg:py-28 lg:pl-10 lg:pr-16 xl:pl-[max(2.5rem,calc((100vw-80rem)/2+2.5rem))]" data-id="element-190" data-mp="2g28xmjwdos9k">
        <div className="max-w-xl" data-id="element-191" data-mp="2pv7n03zp8mu8">
          <p className="font-serif text-xl italic text-copper-light" data-id="element-192" data-mp="2pw91kifxbrgp">For employers</p>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl" data-id="element-193" data-mp="224kcdayefj3z">Find the Leadership Your Next Chapter Requires.</h2>
          <p className="mt-6 text-lg leading-relaxed text-porcelain/75" data-id="element-194" data-mp="2c31aqszo3002">
            Whether you are planning an executive appointment, strengthening your leadership team, or undertaking a confidential search, Aurevane Search Partners provides a structured starting point for your hiring needs.
          </p>
          <ButtonLink to="/employers#inquiry" arrow className="mt-10" data-id="element-195" data-mp="3ijd9av6eijw6">
            Start a Search Conversation
          </ButtonLink>
        </div>
      </div>
      <div className="bg-limestone px-6 py-20 sm:px-12 lg:py-28 lg:pl-16 lg:pr-10 xl:pr-[max(2.5rem,calc((100vw-80rem)/2+2.5rem))]" data-id="element-196" data-mp="p3gjs46pg9dv">
        <div className="max-w-xl" data-id="element-197" data-mp="yz0foql9r82m">
          <p className="font-serif text-xl italic text-copper-deep" data-id="element-198" data-mp="yzs3hf8mk1ic">For candidates</p>
          <h2 className="mt-4 text-3xl font-semibold leading-[1.1] tracking-tight text-aubergine sm:text-4xl" data-id="element-199" data-mp="12zkedylhqjqv">Your Next Opportunity Starts With a Conversation.</h2>
          <p className="mt-6 text-lg leading-relaxed text-plum/75" data-id="element-200" data-mp="b964edgllrkh">
            Experienced leaders can introduce their background, leadership experience, and career aspirations to our team in confidence, for consideration in relevant current and future searches.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-201" data-mp="k3u65tmysr4j">
            <ButtonLink to="/candidates#introduce" variant="dark" data-id="element-202" data-mp="3jp933tpqg5wo">
              Introduce Yourself
            </ButtonLink>
            <ButtonLink to="/opportunities" variant="ghost" arrow data-id="element-203" data-mp="uwm86icxg0s8">
              Explore Leadership Opportunities
            </ButtonLink>
          </div>
        </div>
      </div>
    </section>;
}